
import React, { useEffect, useState } from 'react';

interface Props {
  message: string | null;
  duration?: number;
  type?: 'info' | 'error';
}

const ActionToast: React.FC<Props> = ({ message, duration = 2000, type = 'info' }) => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    if (message) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, duration);
      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [message, duration]);
  
  if (!visible || !message) return null;

  const baseClasses = "fixed top-20 left-1/2 -translate-x-1/2 z-50 text-white px-6 py-3 rounded-lg shadow-lg border-2 animate-[fadeIn_0.5s_ease-out]";
  const typeClasses = type === 'error' 
    ? "bg-red-800/90 border-red-600"
    : "bg-slate-800/90 border-slate-600";
  
  return (
    <div className={`${baseClasses} ${typeClasses}`}>
      {message}
    </div>
  );
};

export default ActionToast;
